import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  ReadMoreIcon,
} from "../../mui";

import ShipmentInquiriesService from "../../services/ShipmentInquiriesService";
import { snackbarActions } from "../../Store/snackbar";
import { useDispatch } from "react-redux";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.selectedNavItemHover.bgColor,
    color: theme.palette.selectedNavItem.color,
  },
}));

const CompletedCanclledInquiries = (props) => {
  const { value, setValue, setFormData } = props;
  const [completedCanclledInquiries, setCompletedCanclledInquiries] = useState(
    []
  );
  const dispatch = useDispatch();

  const handleShowHistory = (row) => {
    setFormData((prev) => ({
      inquiry_id: row.inquiry_id,
      status: row.status,
      user_id: row.user_id,
      first_name: row.first_name,
      last_name: row.last_name,
      organization_name: row.organization_name,
      phone: row.phone,
      email: row.email,
      attention_to: row.attention_to,
      address_line_one: row.address_line_one,
      address_line_two: row.address_line_two,
      city: row.city,
      state: row.state,
      zipcode: row.zipcode,
      study: row.study,
      cohorts: row.cohorts,
      last_modified_status: row.last_modified_status,
      tracking_number: row.tracking_number ? row.tracking_number : "",
    }));
    setValue("two");
  };

  useEffect(() => {
    ShipmentInquiriesService.getInquiryList()
      .then((resp) => {
        setCompletedCanclledInquiries(
          resp.data.filter((row) => {
            if (
              row.status === "completed" ||
              (row.status === "biorep_rejected" &&
                row.last_modified_status === "biorep_rejected")
            ) {
              return row;
            }
          })
        );
      })
      .catch((err) => {
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "error",
            snackbarMessage: err.message,
          })
        );
      });
  }, [value]);

  return (
    <>
      {value === "three" && (
        <Stack
          sx={{
            marginTop: "10px",
          }}
        >
          <Table
            size="small"
            aria-label="Completed and Cancelled Inquiry Table"
          >
            <TableHead color="primary">
              <TableRow>
                <StyledTableCell align="left">Inquiry ID</StyledTableCell>
                <StyledTableCell align="center">Study</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">Show History</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {completedCanclledInquiries.length === 0 && (
                <TableRow>
                  <TableCell align="center" colSpan={3} component="td">
                    No Record Found
                  </TableCell>
                </TableRow>
              )}
              {completedCanclledInquiries.map((row, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell align="left" component="td">
                      {row.inquiry_id}
                    </TableCell>
                    <TableCell align="center" component="td">
                      {row.study}
                    </TableCell>
                    <TableCell align="center" component="td">
                      <span
                        style={{
                          color: row.status === "completed" ? "green" : "red",
                          textTransform: "uppercase",
                        }}
                      >
                        {row.status}
                      </span>
                    </TableCell>
                    <TableCell
                      align="center"
                      onClick={() => handleShowHistory(row)}
                    >
                      <Tooltip
                        title="Show History Detail"
                        style={{ cursor: "pointer" }}
                      >
                        <ReadMoreIcon color="secondary" />
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Stack>
      )}
    </>
  );
};

export default CompletedCanclledInquiries;
